import { observable, runInAction } from "mobx"

import { fetchGetEventsById } from "~/api/events/[id]/get"
import { fetchGetEvents } from "~/api/events/get"
import { Event } from "~/entities/Event"
import { PageInfo } from "~/entities/PageInfo"

interface FetchArgs {
  number?: number
  page?: number
}

export default class EventStore {
  @observable event: Event | null = null
  @observable events: Array<Event> = []
  @observable pageInfo: PageInfo | null = null

  fetch = async (args?: FetchArgs): Promise<{ events: Event[]; pageInfo: PageInfo | null }> => {
    const res = await fetchGetEvents({ page: args?.page })
    const data = res.data.map((datum) => {
      return new Event(datum as any)
    })
    const pageInfo = new PageInfo({
      currentPage: res.meta.current_page,
      lastPage: res.meta.last_page,
      perPage: res.meta.per_page,
      path: res.meta.path,
      from: res.meta.from,
      to: res.meta.to,
      total: res.meta.total,
    })
    runInAction(() => {
      this.events = data
      this.pageInfo = pageInfo
    })
    return {
      events: args && args.number ? this.events.slice(0, args.number) : this.events,
      pageInfo: this.pageInfo,
    }
  }

  fetchById = async (id: number): Promise<Event | null> => {
    const event = await fetchGetEventsById(id)
    if (!event || !event.id) {
      return null
    }
    runInAction(() => {
      this.event = new Event(event as any)
    })
    return this.event
  }
}
